import React, { Suspense } from 'react';
import Logo from '../../components/layout/Logo';
import SideMenu from '../../components/layout/SideMenu';
import Header from '../../components/layout/Header';
import LazyRouteBoundary from '../../components/errors/LazyRouteBoundary';
import { AdminRangeProvider } from './AdminRangeContext';

/**
 * Everything the `/admin` route element is, above the console's own chunk.
 *
 * A component rather than JSX inline in `App.tsx` so this arrangement can be
 * tested: the boundary below is here precisely to catch `AdminLayout`'s chunk
 * failing to arrive, and a test that rebuilt this tree itself would be checking
 * its own copy rather than the one that ships.
 *
 * Everything here is eager and already in the main bundle for other routes, so
 * an admin sees the chrome immediately and the console interior arrives behind
 * the boundary and the Suspense.
 */
const AdminLayout = React.lazy(() => import('./AdminLayout'));

const AdminShell: React.FC = () => (
  <>
    <Logo />
    <SideMenu />
    <Header />
    <main className="main-content">
      <AdminRangeProvider>
        {/*
          OUTSIDE the chunk it protects, which is the whole reason it is not
          the console's own boundary. `ConsoleErrorBoundary` ships inside the
          admin chunk, so it cannot catch that chunk failing to load; an admin
          clicking Admin after a deploy would take a ChunkLoadError all the way
          to the boundary in index.tsx, which replaces the entire application
          with one line of text. The first console navigation of a session is
          the one most likely to be crossing a release.

          The Suspense fallback is empty on purpose: the chrome above is already
          painted, so there is no blank page for a spinner to cover.
        */}
        <LazyRouteBoundary>
          <Suspense fallback={null}>
            <AdminLayout />
          </Suspense>
        </LazyRouteBoundary>
      </AdminRangeProvider>
    </main>
  </>
);

export default AdminShell;
